interface QualityAssuranceIconProps {
    size?: number;
    className?: string;
  }
  
  export default function QualityAssuranceIcon({ 
    size = 128, 
    className = "" 
  }: QualityAssuranceIconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        {/* Platform/pan on top */}
        <rect
          x="5"
          y="28"
          width="70"
          height="6"
          rx="3"
          fill="currentColor"
          fillOpacity="0.05"
          stroke="currentColor"
          strokeWidth="2"
        />
        
        {/* Small connector between pan and base - black */}
        <rect
          x="37"
          y="34"
          width="6"
          height="4"
          rx="1"
          fill="currentColor"
        />
        
        {/* Scale base/body - trapezoid shape with rounded corners */}
        <path
          d="M 18 38 Q 15 38 15 41 L 8 69 Q 8 72 11 72 L 69 72 Q 72 72 72 69 L 65 41 Q 65 38 62 38 Z"
          fill="currentColor"
          fillOpacity="0.08"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        
        {/* Small legs at bottom - black */}
        <rect x="10" y="72" width="8" height="3" rx="1.5" fill="currentColor" />
        <rect x="62" y="72" width="8" height="3" rx="1.5" fill="currentColor" />
        
        {/* Speech bubbles on the platform - 4 bubbles alternating left/right */}
        <g>
          {/* Bubble 1 - tail at bottom-left */}
          <path
            d="M 9 15 C 9 14 9 13 10 13 L 19 13 C 20 13 20 14 20 15 L 20 22 C 20 23 20 24 19 24 L 12 24 L 10 26 L 10 24 C 9 24 9 23 9 22 Z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
            strokeLinejoin="round"
          />
          <circle cx="12.5" cy="17.5" r="1.5" fill="currentColor" />
          <rect x="10.5" y="20" width="5" height="1.5" rx="0.75" fill="currentColor" opacity="0.5" />
          
          {/* Bubble 2 - tail at bottom-center */}
          <path
            d="M 24 15 C 24 14 24 13 25 13 L 34 13 C 35 13 35 14 35 15 L 35 22 C 35 23 35 24 34 24 L 27 24 L 25 26 L 25 24 C 24 24 24 23 24 22 Z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
            strokeLinejoin="round"
          />
          <rect x="26" y="16" width="6" height="1.8" rx="0.9" fill="currentColor" />
          <rect x="26" y="19.5" width="4" height="1.2" rx="0.6" fill="currentColor" opacity="0.4" />
          
          {/* Bubble 3 - tail at bottom-center */}
          <path
            d="M 39 15 C 39 14 39 13 40 13 L 49 13 C 50 13 50 14 50 15 L 50 22 C 50 23 50 24 49 24 L 42 24 L 40 26 L 40 24 C 39 24 39 23 39 22 Z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
            strokeLinejoin="round"
          />
          <circle cx="42.5" cy="17.5" r="1.5" fill="currentColor" opacity="0.6" />
          <circle cx="45.5" cy="17.5" r="1.5" fill="currentColor" />
          
          {/* Bubble 4 - tail at bottom-right */}
          <path
            d="M 54 15 C 54 14 54 13 55 13 L 64 13 C 65 13 65 14 65 15 L 65 22 C 65 23 65 24 64 24 L 62 24 L 61 26 L 60 24 L 55 24 C 54 24 54 23 54 22 Z"
            stroke="currentColor"
            strokeWidth="1.5"
            fill="none"
            strokeLinejoin="round"
          />
          <rect x="56" y="16" width="6" height="1.8" rx="0.9" fill="currentColor" opacity="0.6" />
          <rect x="56" y="19.5" width="5" height="1.5" rx="0.75" fill="currentColor" />
        </g>
        
        {/* Digital display screen on front of base */}
        <rect
          x="18"
          y="45"
          width="44"
          height="20"
          rx="2"
          fill="currentColor"
          fillOpacity="0.12"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        
        {/* Bar graph metrics */}
        
        {/* Bar 1 - Empathy (85%) */}
        <g>
          <text x="22" y="51" fontSize="3.5" fill="currentColor" opacity="0.6">Empathy</text>
          <rect x="40" y="48.5" width="18" height="2.5" rx="1.25" fill="currentColor" opacity="0.15" />
          <rect x="40" y="48.5" width="15.3" height="2.5" rx="1.25" fill="currentColor" />
        </g>
        
        {/* Bar 2 - Violations (90%) */}
        <g>
          <text x="22" y="56" fontSize="3.5" fill="currentColor" opacity="0.6">Violations</text>
          <rect x="40" y="53.5" width="18" height="2.5" rx="1.25" fill="currentColor" opacity="0.15" />
          <rect x="40" y="53.5" width="16.2" height="2.5" rx="1.25" fill="currentColor" />
        </g>
        
        {/* Bar 3 - Adherence (80%) */}
        <g>
          <text x="22" y="61" fontSize="3.5" fill="currentColor" opacity="0.6">Adherence</text>
          <rect x="40" y="58.5" width="18" height="2.5" rx="1.25" fill="currentColor" opacity="0.15" />
          <rect x="40" y="58.5" width="14.4" height="2.5" rx="1.25" fill="currentColor" />
        </g>
      </svg>
    );
  }
  